<template>

    <transition name="expand" @enter="enter" @leave="leave" :css="!fixed">
        <div v-if="false" class="flex flex-wrap items-center gap-y-0 gap-x-2 px-4">
            <div v-for="flow in flows_with_icons" :key="flow.label"
                class="flex flex-row items-center gap-x-2 rounded-md py-1 px-3 mb-3 bg-gray-100 text-gray-600">
                <component v-if="flow.icon" :is="flow.icon" class="size-8"></component>
                <span v-else-if="flow.svg" v-html="flow.svg"></span>
                <span class="text-xs">{{ flow.label }}</span>
            </div>
        </div>
    </transition>
    <transition name="expand" @enter="enter" @leave="leave" :css="!fixed">
        <div v-if="visible || fixed"
            class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 items-center gap-x-4 px-5 overflow-hidden w-full py-2"
            style="grid-template-rows: 1fr;">

            <div v-for="(flow, index) in flows_with_icons" :key="flow.label"
                class="flex-col justify-start items-start gap-y-2 rounded-md py-3 px-3 mb-3 border border-gray-200 text-gray-500 bg-white w-full h-full"
                :class="{
                    'hidden md:flex': index == 1,
                    'hidden lg:flex': index == 2,
                    'flex': index == 0,
                }">
                <div class="flex flex-row items-center gap-x-2">
                    <component v-if="flow.icon" :is="flow.icon" class="size-4"></component>
                    <span v-else-if="flow.svg" v-html="flow.svg"></span>
                    <span class="text-sm font-semibold">{{ flow.label }}</span>
                </div>
                <span class="text-xs text-left">{{ flow.description }}</span>
            </div>

            <a :href="docs" target="_blank" title="Explore" @click.stop
                class="flex flex-col justify-start items-start gap-y-2 rounded-md py-3 px-3 mb-3 border border-birdie-blue text-birdie-blue bg-white w-full h-full hover:bg-birdie-blue hover:text-white transition-colors duration-300 group/more">
                <div class="flex flex-row items-center justify-between w-full gap-x-2 ">
                    <BookOpenIcon class="size-4"></BookOpenIcon>
                    <span class="text-sm font-semibold">Explore more…</span>
                    <span class="flex-grow"></span>
                    <ArrowRightIcon
                        class="size-4 opacity-0 group-hover/more:opacity-100 transition-all duration-300 -translate-x-3 group-hover/more:translate-x-0">
                    </ArrowRightIcon>
                </div>
                <span class="text-xs text-left" v-if="is_custom">Discover popular flows for Birdie</span>
                <span class="text-xs text-left" v-else>Discover popular flows for Birdie&nbsp;x&nbsp;{{ name
                }}</span>
            </a>
        </div>
    </transition>
    <transition name="expand" @enter="enter" @leave="leave" :css="!fixed">
        <div v-if="false" class="flex flex-wrap items-center gap-y-0 gap-x-2 pl-8 pr-4">
            <div class="flex flex-row items-center gap-x-2 rounded-md py-1 px-0 mb-3 text-gray-600 font-bold">Leverage:
            </div>
            <div v-for="flow in flows_with_icons" :key="flow.label"
                class="flex flex-row items-center gap-x-2 rounded-md py-1 px-0 mb-3  text-gray-600">
                <component v-if="flow.icon && false" :is="flow.icon" class="size-8"></component>
                <span v-else-if="flow.svg && false" v-html="flow.svg"></span>
                <span class="text-sm">{{ flow.label }}</span>
            </div>
        </div>
    </transition>
</template>

<script>

import {
    ArrowPathRoundedSquareIcon,
    PencilSquareIcon,
    TableCellsIcon,
    CodeBracketSquareIcon,
    ChatBubbleBottomCenterTextIcon,
    ChatBubbleLeftRightIcon,
    BellIcon,
    Cog6ToothIcon,
    ChatBubbleBottomCenterIcon,
    BookOpenIcon,
    ArrowRightIcon

} from "@heroicons/vue/16/solid";


export default {
    props: {
        flows: {
            type: Array,
            default: [],
        },
        visible: {
            type: Boolean,
            default: false,
        },
        fixed: {
            type: Boolean,
            default: false,
        },
        docs: {
            type: String,
            default: '#',
        },
        is_custom: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '',
        }
    },
    components: {
        ArrowPathRoundedSquareIcon,
        PencilSquareIcon,
        TableCellsIcon,
        CodeBracketSquareIcon,
        ChatBubbleBottomCenterTextIcon,
        ChatBubbleLeftRightIcon,
        BellIcon,
        Cog6ToothIcon,
        ChatBubbleBottomCenterIcon,
        BookOpenIcon,
        ArrowRightIcon

    },
    data() {
        return {
            flows_with_icons: [],
            defaultIcon: 'ArrowPathRoundedSquareIcon',
            defaultColor: 'bg-yellow-500',
        }
    },
    created() {
        for (var i = 0; i < this.flows.length; i++) {
            if (i > 2) break;
            let flow = this.flows[i]

            if (!flow.icon && !flow.svg) {
                flow.icon = this.defaultIcon
                flow.color = this.defaultColor;
            }
            this.flows_with_icons.push(flow);
        }
    },
    mounted() {

    },
    methods: {
        enter(element) {
            if (this.fixed) return;

            const width = getComputedStyle(element).width;
            element.style.width = width;
            element.style.position = 'absolute';
            element.style.visibility = 'hidden';
            element.style.height = 'auto';

            const height = getComputedStyle(element).height;
            element.style.width = null;
            element.style.position = null;
            element.style.visibility = null;
            element.style.height = 0;

            // Force repaint
            getComputedStyle(element).height;

            // Add transition
            element.style.height = height;
        },

        leave(element) {
            if (this.fixed) return;

            const height = getComputedStyle(element).height;
            element.style.height = height;

            // Force repaint
            getComputedStyle(element).height;

            // Add transition
            element.style.height = 0;
        }
    }

}

</script>
<style scoped>
.expand-enter-active,
.expand-leave-active {
    transition: height 0.3s ease-in-out;
    overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
    height: 0;
}
</style>
